import React from 'react';
import PropTypes from 'prop-types';
import { MenuContainer, ItemsList, Item, ItemContent } from './styles';

const TabMenu = ({ menuItems, underlined, style }) => (
  <MenuContainer style={style}>
    <ItemsList>
      {menuItems.map(item => (
        <Item underlined={underlined} key={item.name} isActive={item.isActive}>
          {item.isActive ? (
            <ItemContent underlined={underlined}>{item.name}</ItemContent>
          ) : (
            <ItemContent
              underlined={underlined}
              role="button"
              tabIndex="0"
              onClick={item.action}
              onKeyPress={() => {}}
            >
              {item.name}
            </ItemContent>
          )}
        </Item>
      ))}
    </ItemsList>
  </MenuContainer>
);

TabMenu.defaultProps = {
  underlined: false,
  style: undefined,
};

TabMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      isActive: PropTypes.bool,
      action: PropTypes.func,
    }),
  ).isRequired,
  underlined: PropTypes.bool,
  style: PropTypes.shape({}),
};

export default TabMenu;
